import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Paper from '@mui/material/Paper';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import parse from 'autosuggest-highlight/parse';
import { debounce } from '@mui/material/utils';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/TextField": TextField, "@mui/material/Autocomplete": Autocomplete, "@mui/material/Paper": Paper, "@mui/icons-material/LocationOn": LocationOnIcon, "@mui/material/Grid": Grid, "@mui/material/Typography": Typography, "autosuggest-highlight/parse": parse, "@mui/material/utils": { debounce } } } });
export default ClientProvider;
